import {  Feature, InjectorService } from '@tencent/workbench';
import { ISolidFillShower } from '@tencent/drawing-drawer-components';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { alphaToOpacity } from '@framework/workbench/drawer/utils';
import React from 'react';
import { SolidFillFeature } from '@framework/workbench/drawer/ui/fill/solid-fill/solid-fill-feature';
import ColorPickerContainer from '@src/js/common/ark-extensions/dc-components/color-picker/color-picker-container';
import { ColorPickerType } from '@src/js/common/ark-extensions/dc-components/color-picker/type';

@Feature()
export class SolidFillShower extends BaseFillFeature implements ISolidFillShower {
    private solidFillFeature: SolidFillFeature;

    public constructor() {
        super();
        this.solidFillFeature = InjectorService.get(SolidFillFeature);
    }

    public getDropContent = () => <ColorPickerContainer
        selectedTdColor={this.getFillValue()}
        colorPickerType={ColorPickerType.StandardPC}
        onColorChange={(tdColor, from) => {
            this.solidFillFeature.handleColorChange?.(tdColor, from);
        }}
    />;

    public getSolidFillOpacity() {
        const solidOpacityObj = { solidOpacity: alphaToOpacity(this.solidFillFeature.value.solidFillColor.alpha) };
        return this.getShownValue(this.solidFillFeature.getInputParams().key, solidOpacityObj);
    }

    public getSolidFillColor = () => {
        const color = this.getFillValue();
        if (color) {
            return color.rgba;
        }
    };

    public shouldEyeDropperDisabled = () => !this.getColorPickerManager()?.useNewEyeDropper;
}
